import TransactionListWidgetView from './TransactionListWidgetView.vue';

export const type = 'transactionList';
export const view = TransactionListWidgetView;

export function builder() {
  return {
    type,
    pageNumber: 1,
    numPages: 1,
    numTransactionsInPage: 1,
    top: 0,
  };
}
